const initialeState = {
    current_page : 'dossiers',
    centerPageArg : null,
    filterForm : null,
    checkForms: null,

}

const DashboardReducer = (state=initialeState, action) => {
    switch (action.type) {
        case  'SET_CURRENT_PAGE':
            return {
                ...state,
                current_page: action.data,
                centerPageArg: (action.arg)?action.arg:null,
            }
        case 'SET_CHECK_FORMS':
            return {
                ...state,
                checkForms: action.data
            }
        case 'SET_DASHBORD_FILTER_FORM':
            return {
                ...state,
                filterForm: action.data,
            }
        default:
            return state
    }
}

export default DashboardReducer
